/**
 * @fileoverview Connect currency-form editing to caller-owned numeric state. Display text is transient; committed values are numbers or null and are emitted on blur through the shared value envelope. Formatting here is a form concern, separate from billing or accounting calculations.
 */

import React, { useState, useEffect } from 'react'

const inputStyle = {
    width: '100%',
    padding: '0.6rem 0.75rem',
    paddingLeft: '1.75rem',
    borderRadius: '6px',
    border: '1px solid var(--surface-border)',
    fontSize: '1rem',
    backgroundColor: 'var(--surface-section)',
    color: 'var(--text-color)',
    fontFamily: 'inherit'
}

const wrapperStyle = {
    position: 'relative',
    width: '100%'
}

const prefixStyle = {
    position: 'absolute',
    left: '0.75rem',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'var(--text-color-secondary, #64748b)',
    pointerEvents: 'none',
    fontSize: '1rem'
}



function formatCurrency(val) {
    if (val === null || val === undefined || val === '') return ''
    const num = Number(val)
    if (Number.isNaN(num)) return ''
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}



function parseCurrency(str) {
    if (!str) return null
    const cleaned = str.replace(/[^0-9.-]/g, '')
    const num = parseFloat(cleaned)
    return Number.isNaN(num) ? null : num
}

/**
 * The parent owns the committed number. onValueChange takes precedence over onChange; the selected callback receives {value: number|null} on blur. Currency display precision does not define domain rounding policy.
 */
function AppCurrencyInput({ id, value, onValueChange, onChange }) {
    const [display, setDisplay] = useState('')

    useEffect(() => {
        setDisplay(formatCurrency(value))
    }, [value])

    const handleChange =

    (e) => {
        setDisplay(e.target.value)
    }

    const handleBlur =

    () => {
        const num = parseCurrency(display)
        setDisplay(formatCurrency(num))
        const cb = onValueChange || onChange
        if (cb) cb({ value: num })
    }

    const handleFocus =

    () => {
        // Show raw number on focus for easy editing
        if (value !== null && value !== undefined) {
            setDisplay(String(value))
        }
    }

    return (
        <div style={wrapperStyle}>
            <span style={prefixStyle}>$</span>
            <input
                id={id}
                type="text"
                inputMode="decimal"
                value={display}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                style={inputStyle}
            />
        </div>
    )
}

export default AppCurrencyInput
